import type { ReactNode } from 'react'

/** Grupo vazio não vira seção vazia — some. */
export const SuggestionSection = ({
  title,
  subtitle,
  isEmpty,
  children
}: {
  title: string
  subtitle?: string
  isEmpty: boolean
  children: ReactNode
}) => {
  if (isEmpty) return null

  return (
    <section className="mb-6">
      <h2 className="text-lg font-semibold text-foreground">{title}</h2>

      {subtitle && <p className="mt-0.5 mb-3 text-sm text-gray-700">{subtitle}</p>}

      <div className={subtitle ? 'grid gap-3' : 'mt-3 grid gap-3'}>{children}</div>
    </section>
  )
}
